<template>
  <div class="user-concepts">
    <div v-if="user.concepts.length > 0">
      <div class="concept-tag" v-for="(conceptId, index) in user.concepts" :key="index">
        {{ getConceptName(conceptId) }} <span class="concept-remove" @click="removeConceptPermission(conceptId)">[x]</span>
      </div>
    </div>
    <div class="concept-add concept-tag" v-if="conceptsNotYetPermissioned.length != 0">
      Add:
      <select class="select-concept" name="concept-add-select" v-model="newConceptPermission">
       <option v-for="(concept, index) in conceptsNotYetPermissioned" :key="index" :value="concept.id">{{ concept.name }}</option>
      </select>
    </div>

  </div>
</template>

<script>

export default {
  name: 'UserConcepts',
  components: {

  },
  props: ['user'],
  data() {
      return {
        newConceptPermission: null
      }
  },
  computed: {
    conceptsNotYetPermissioned(){
      let allConcepts = this.$store.state.org.concepts;
      return allConcepts.filter(c => !this.user.concepts.includes(c.id));
    }
  },
  mounted() {

  },
  methods: {
    getConceptName(conceptId){
      let concept = this.$store.state.org.concepts.find(c => c.id == conceptId);
      return concept.name || 'N/A';
    },
    addConceptPermission(conceptId){
      this.$store.dispatch('addConceptPermission', {userId: this.user.id, conceptId})
      this.newConceptPermission = null;
    },
    removeConceptPermission(conceptId){
      this.$store.dispatch('removeConceptPermission', {userId: this.user.id, conceptId})
    }
  },
  watch: {
    'newConceptPermission' (to){
      if(to != null){
        this.addConceptPermission(to);
      }
    }
  }
}

</script>

<style>

.user-concepts {
  margin-top: 8px;
  text-align: right;
}

.concept-tag {
  padding: 4px 12px;
  font-size: 0.8rem;
  width: fit-content;
  background: var(--beige-400);
  border-radius: 200px;
  margin-bottom: 4px;
}

.concept-remove {
  opacity: 0.75;
}

.concept-remove:hover{
  cursor: pointer;
  opacity: 1;
}

</style>
